import types from '../ActionTypes'
export const ACTION_LOGIN=
{
    type:types.TYPE_LOGIN,
    payload:
    {
       userId : undefined,
       userName : undefined,
       type : undefined
    }
}
export const ACTION_LOGOUT=
{
    type:types.Type_LOGOUT,
    payload:
    {
       userId : undefined,
       userName : undefined,
       type : undefined
    }
}